import React, { useEffect, useState, useContext } from "react";
import { PopupContext } from "../../index";
import { EventType } from "../../vars";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import { saveEvent } from "../../rules/ruleService";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as deviceService from "../../devices/deviceService";

function AddEventKeyword({ deviceTypeId }) {

    const initialState = {
        eventKeyword: null,
        selectedDeviceType: null
    };

    const { setPopup } = useContext(PopupContext);
    const [state, setState] = useState(initialState);
    const [lastUpdated, setLastUpdated] = useState(Date.now);

    const fetchData = async () => {
        try {
            const deviceTypes = await deviceService.loadDeviceTypes();
            const deviceType = deviceTypes.find((e) => e.id === deviceTypeId);
            setState({ ...state, selectedDeviceType: deviceType });
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        fetchData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [lastUpdated]);

    const confirmEventCreation = async (eventkeyword) => {
        const newEvent = {
            name: eventkeyword,
            deviceType: state.selectedDeviceType,
            value: eventkeyword,
            type: EventType.KEYWORD
        };
        await saveEvent(newEvent);
        await deviceService.eventsList();
        setState({ ...state, eventKeyword: null });
        setLastUpdated(Date.now);
    };

    const onAddEventClick = () => setPopup(
        {
            type: POPUP_TYPES.CREATE_EVENT_ON_ADD_DEVICE,
            eventkeywordvalue: state.eventKeyword,
            confirm: confirmEventCreation
        }
    );

    return (
        <button
            type="button"
            className="modal-v2-step3-add-keyword-btn"
            onClick={() => { onAddEventClick(); }}
        >
            Add Event Keyword
        </button>
    );
}

function mapStateToProps(state) {
    debug("AddEventKeyword mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        events: addDeviceModal.events || [],
        deviceTypeId: addDeviceModal.deviceTypeId
    };
}

export default connect(mapStateToProps)(AddEventKeyword);
